'use client'

import { XMarkIcon } from '@heroicons/react/20/solid'
import { useState } from 'react'
import Link from 'next/link'

export function Banner() {
    const [isVisible, setIsVisible] = useState(true)

    if (!isVisible) return null

    return (
        <div className="relative isolate flex items-center gap-x-6 overflow-hidden bg-linear-to-r from-sky-400 to-sky-600 px-6 py-2.5 sm:px-3.5 sm:before:flex-1">
            <div
                aria-hidden="true"
                className="absolute top-1/2 left-[max(-7rem,calc(50%-52rem))] -z-10 -translate-y-1/2 transform-gpu blur-2xl"
            >
                <div
                    className="aspect-577/310 w-[36.0625rem] bg-sky-500 opacity-30"
                />
            </div>
            <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
                <p className="text-sm/6 text-white">
                    <strong className="font-semibold">Spring Sale 2025: </strong>
                    The best time to buy a water purifier is now!
                </p>
                <Link
                    href="https://shop.waterdoctor.ca/"
                    className="flex-none rounded-full bg-white px-3.5 py-1 text-sm font-semibold text-sky-600 shadow-xs hover:bg-gray-100 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
                >
                    Shop now <span aria-hidden="true">&rarr;</span>
                </Link>
            </div>
            <div className="flex flex-1 justify-end">
                <button
                    type="button"
                    className="-m-3 p-3 focus-visible:outline-offset-[-4px]"
                    onClick={() => setIsVisible(false)}
                >
                    <span className="sr-only">Dismiss</span>
                    <XMarkIcon className="size-5 text-white hover:text-gray-100" aria-hidden="true" />
                </button>
            </div>
        </div>
    )
}
